module.exports = __webpack_public_path__ + "static/3-c481972b4162ed8f3712ee92d80f0c03.png";